import React from "react";
import { signInWithGoogle } from "../services/auth";

const SignUp = () => {
  return (
    <div>
      <h2>Sign Up</h2>
      <button onClick={signInWithGoogle}>Sign up with Google</button>
    </div>
  );
};

export default SignUp;
